var map = {
	"./comingsoon.png": "12ce",
	"./comingsoon2.jpg": "6677",
	"./ewallet1.png": "8710",
	"./ewallet2.png": "4f8e",
	"./ewallet3.png": "7b9f",
	"./laptop.png": "1104",
	"./laptop2.png": "9fe7",
	"./mdi_language-css3.png": "1273",
	"./mdi_language-html5.png": "9cc0",
	"./mdi_language-javascript.png": "d435",
	"./mdi_nodejs.png": "8f11",
	"./mdi_react.png": "d010",
	"./mdi_vuejs.png": "c002",
	"./oplask1.png": "4a67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";